<script>
export default {
  name: "PrintPage",
  props: {
    printList: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      cardList: []
    };
  },
  watch: {
    printList(val) {
      this.cardList = val;
    }
  }
};
</script>


<template src="./template.html"></template>
<style lang="scss" src="./style.scss" />
